import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {

  constructor(private translateService: TranslateService) { }

  /**
   * translate
   * @param message
   * @param prefix
   */
  translate(message: string, prefix = 'api.'): string {
    return this.translateService.instant(prefix + message);
  }

}
